import { render, staticRenderFns } from "./widget_curve_capital.vue?vue&type=template&id=760464d6&scoped=true&"
import script from "./widget_curve_capital.vue?vue&type=script&lang=js&"
export * from "./widget_curve_capital.vue?vue&type=script&lang=js&"
import style0 from "./widget_curve_capital.vue?vue&type=style&index=0&id=760464d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760464d6",
  null
  
)

export default component.exports